import { IconsProps } from './IconsProps';

const Close = ({
  className = '',
  viewBox = '0 0 36 36',
  width = 36,
  height = 36,
  onClick,
  svgFill = 'currentColor',
  ariaLabel,
  ariaHidden,
}: IconsProps) => {
  return (
    <svg
      className={className}
      viewBox={viewBox}
      width={`${width}px`}
      height={`${height}px`}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      onClick={onClick}
      fill={svgFill}
      aria-label={ariaLabel}
      aria-hidden={ariaHidden}
    >
      <g clipPath="url(#clip0_2642_17616)">
        <path
          d="M29.9541 27.03L20.7701 17.935L29.8621 8.76101L27.0301 5.95401L17.9401 15.133L8.7641 6.04501L5.9541 8.85501L15.1401 17.96L6.0451 27.144L8.8551 29.954L17.9671 20.762L27.1471 29.862L29.9541 27.03Z"
          fill={svgFill}
        />
      </g>
      <defs>
        <clipPath id="clip0_2642_17616">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(6 6)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Close;
